import { FieldGroupItems } from './FieldGroupItems';
import { FieldGroupLegend } from './FieldGroupLegend';
import { FieldGroupRoot } from './FieldGroupRoot';

export const FieldGroup = {
  Root: FieldGroupRoot,
  Legend: FieldGroupLegend,
  Items: FieldGroupItems,
};
